import React, { useState, useEffect } from "react";
import styles from "./ContractType.module.sass";
import cn from "classnames";
import Card from "../../../components/Card";
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";
import { getStudentContractStatus } from "../../../services/dashboard.service"; 

const legend = [
    {
        title: "Sous contrat",
        color: "#B5E4CA",
    },
    {
        title: "Sans contrat",
        color: "#FFCC5C",
    },
];

// Données par défaut pour le chargement initial ou en cas d'erreur
const defaultData = [
    { name: "Sous contrat", value: 0 },
    { name: "Sans contrat", value: 0 },
];
const COLORS = ["#B5E4CA", "#FFCC5C"];

const ContractType = ({ className }) => {
    const [loading, setLoading] = useState(true);
    const [contractData, setContractData] = useState(defaultData);
    
    useEffect(() => {
        const fetchStatus = async () => { 
            try {
                setLoading(true);
                const data = await getStudentContractStatus(); 
                if (data && data.length > 0) {
                    setContractData(data);
                } else {
                    setContractData(defaultData); 
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des statistiques de contrats:', error);
                setContractData(defaultData); 
            } finally {
                setLoading(false);
            }
        };
        
        fetchStatus(); 
    }, []);

    return (
        <Card
            className={cn(styles.card, className)}
            title="Statut des étudiants"
            classTitle="title-purple"
        >
            <div className={styles.chart}>
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart width={400} height={400}>
                        <Tooltip
                            contentStyle={{
                                backgroundColor: "#272B30",
                                borderColor: "rgba(255, 255, 255, 0.12)",
                                borderRadius: 8,
                                boxShadow:
                                    "0px 4px 8px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.1), inset 0px 0px 1px #000000",
                            }}
                            labelStyle={{
                                fontSize: 12,
                                fontWeight: "500",
                                color: "#fff",
                            }}
                            itemStyle={{
                                padding: 0,
                                textTransform: "capitalize",
                                fontSize: 12,
                                fontWeight: "600",
                                color: "#fff",
                            }}
                            formatter={(value) => [`${value} étudiants`, '']}
                        />
                        <Pie
                            data={loading ? defaultData : contractData}
                            cx={140}
                            cy={110}
                            innerRadius={88}
                            outerRadius={110}
                            fill="#8884d8"
                            paddingAngle={1}
                            dataKey="value"
                        >
                            {(loading ? defaultData : contractData).map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={COLORS[index % COLORS.length]}
                                />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </div>
            <div className={styles.legend}>
                {legend.map((x, index) => (
                    <div className={styles.indicator} key={index}>
                        <div
                            className={styles.color}
                            style={{ backgroundColor: x.color }}
                        ></div>
                        {x.title}
                    </div>
                ))}
            </div>
        </Card>
    );
};

export default ContractType;
